import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { BaseService } from '../../../shared/services/base.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { Page } from '../../../models/list/page.model';
import { BookingDetailService } from './booking-detail.service';
import { BaseUrl } from '../../../shared/urls/base.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { BookingDetailsModel, BookingStatus } from '../../../models/booking/booking-details.model';


@Component({
  selector: 'app-booking-details',
  templateUrl: 'booking-detail.component.html',
  providers: [BookingDetailService]
})

export class BookingDetailsPopupComponent implements OnInit {
  public page = new Page();
  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total
  };
  public appConstants = AppConstants;
  public dataDetails = new BookingDetailsModel();
  public dataStatus = [];
  public dataSelectStatus = [];
  public bookingId: any;
  public dataclinicType = [];
  public bookingForm: FormGroup;
  public dataRow = [];
  public success = false;
  public customClasses = AppConstants.table.footerClasses;
  public bookingStatus = BookingStatus;
  public isDisableClinicType: boolean = false;
  constructor(
    public utility: Utility,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<BookingDetailsPopupComponent>,
    public bookingDetailService: BookingDetailService
  ) {
    this.createForm();
  }
  ngOnInit() {
    this.page.size = 5;
    this.setPage({ offset: 0 });
  }

  onCloseDialog(data) {
    this.dialogRef.close(data);
  }

  createForm() {
    this.bookingForm = this.formBuilder.group({
      status: [''],
      centreId: [localStorage.getItem(AppConstants.localStorage.centreId)],
      clinicId: ['', [Validators.required]],
      isConfirm: [''],
      callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL,
    });
  }

  setPage(pageInfo) {
    this.bookingDetailService.getBookingDetail(this.data.id).subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataDetails = data;
          this.dataRow = data['members'];
          // if status is arrived then disable clinic type
          if (this.dataDetails.status === this.bookingStatus.Arrived) {
            this.bookingForm.controls['clinicId'].disable();
            this.isDisableClinicType = true;
          }
          this.initData();
        }
      }
    );
  }

  onChangeStatus(event) {
    const value = parseInt(event.target.value, 0);
    this.dataDetails.status = value;
  }

  initData() {
    this.bookingDetailService.getDataclinicType().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataclinicType = data;
        }
      }
    );
    this.bookingDetailService.getDataStatus().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.dataStatus = data.list;

          // clear status existed
          this.dataSelectStatus = [];
          this.initStatus();
        }
      }
    );
  }

  initStatus() {
    this.dataStatus.forEach(i => {
      switch (this.dataDetails.status) {
        case BookingStatus.NewBooking:
          if (i.id === BookingStatus.NewBooking || i.id === BookingStatus.Confirmed) {
            this.dataSelectStatus.push(i);
          }
          break;
        case BookingStatus.Confirmed: {
          if (i.id !== BookingStatus.NewBooking) {
            this.dataSelectStatus.push(i);
          }
          break;
        }
        case BookingStatus.Arrived: {
          if (i.id === BookingStatus.Arrived) {
            this.dataSelectStatus.push(i);
            const crtStatus = this.bookingForm.controls.status;
            crtStatus.disable();
          }
          break;
        }
        case BookingStatus.DNA: {
          if (i.id !== BookingStatus.Confirmed && i.id !== BookingStatus.NewBooking) {
            this.dataSelectStatus.push(i);
          }
          break;
        }
        case BookingStatus.Cancelled: {
          if (i.id === BookingStatus.Cancelled) {
            this.dataSelectStatus.push(i);
          }
          break;
        }
      }
    });
  }

  onRemoveDetails() {
    this.dialogService.openConfirmationDialog({ message: AppMessages.bookingDetails.remove }).subscribe(
      (result) => {
        if (result) {
          this.bookingDetailService.removeBooking(this.data.id).subscribe(
            result1 => {
              if (result1) {
                this.onCloseDialog(true);
              }
            }
          );
        }
      });
  }

  onSubmit() {
    this.dataDetails.listMembers = this.dataRow;
    if (this.bookingForm.controls.status.valid) {
      if (this.dataDetails.status == BookingStatus.Confirmed) {
        this.bookingForm.controls['isConfirm'].setValue('true');
        this.bookingDetailService.confirmBookingDetail(this.data.id, this.bookingForm.value).subscribe(
          result => {
            if (result) {
              const data = result.json();
              if (data.message !== undefined && data.message !== null) {
                this.dialogService.openSuccessDialog({ message: data.message.message });
              }
              this.onCloseDialog(data.result);
            }
          }
        );
      }
      else if (this.dataDetails.status == BookingStatus.Cancelled) {
        const data = {
          message: AppMessages.bookingDetails.statusCancelled
        };
        // if success save data
        this.dialogService.openConfirmationDialog(data).subscribe(
          result => {
            if (result) {
              this.bookingDetailService.savingBookingDetail(this.data.id, this.bookingForm.value).subscribe(
                result => {
                  if (result) {
                    this.onCloseDialog(result.json());
                  }
                }
              );
            }
          }
        );
      } else if ((this.dataDetails.status) == BookingStatus.Arrived) {
        if (this.bookingForm.controls.clinicId.valid) {
          this.bookingForm.controls['isConfirm'].setValue('false');
          this.bookingDetailService.savingBookingDetail(this.data.id, this.bookingForm.value).subscribe(
            result => {
              if (result) {
                const data = result.json();
                if (data.message) {
                  this.dialogService.openConfirmationDialog({ message: data.message }).subscribe(
                    comfirm => {
                      if (comfirm) {
                        this.bookingForm.controls['isConfirm'].setValue('true');
                        this.bookingDetailService.savingBookingDetail(this.data.id, this.bookingForm.value).subscribe(
                          result1 => {
                            this.onCloseDialog(result1.json());
                            this.bookingForm.controls['isConfirm'].setValue('false');
                          }
                        );
                      }
                    }
                  );
                }
                else {
                  this.onCloseDialog(data);
                  this.bookingForm.controls['isConfirm'].setValue('false');
                }
              }
            }
          );
        }
      } else {
        this.bookingForm.controls['isConfirm'].setValue('true');
        this.bookingDetailService.savingBookingDetail(this.data.id, this.bookingForm.value).subscribe(
          result => {
            if (result) {
              this.onCloseDialog(result.json());
            }
          }
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/booking-detail/booking-detail.component.ts